<template>
  <div class="d-flex flex-column gap-4 w-100">
    <div class="d-flex justify-content-between align-items-center w-100">
      <LoadingSkeleton :class="`${$style.w10} ${$style.h30}`" />
      <template v-if="showCompareCheckbox">
        <LoadingSkeleton
          :class="`${$style['compare-checkbox']} ${$style.w15} ${$style.h30}`"
        />
      </template>
    </div>
    <div class="d-flex gap-3">
      <LoadingSkeleton :class="`w-25 ${$style.h40}`" />
      <LoadingSkeleton :class="`w-25 ${$style.h40}`" />
    </div>
    <div class="container">
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3">
        <div
          v-for="i in [1, 2, 3]"
          :key="i"
          class="col d-flex flex-column align-items-center gap-3 gap-sm-2 mt-2 mb-2"
        >
          <LoadingSkeleton
            :class="`${$style.w80px} ${$style.h80px} ${$style.r50}`"
          />
          <LoadingSkeleton :class="`w-25 ${$style.h20}`" />
          <LoadingSkeleton :class="`w-50 ${$style.h20}`" />
        </div>
      </div>
    </div>
    <div>
      <LoadingSkeleton :class="`w-75 ${$style.h20}`" />
      <LoadingSkeleton :class="`w-75 ${$style.h20}`" />
      <LoadingSkeleton :class="`w-50 ${$style.h20}`" />
    </div>
    <div v-for="i in [1, 2, 3]" :key="i" class="d-flex flex-column gap-2">
      <LoadingSkeleton :class="`w-25 ${$style.h20}`" />
      <div
        class="container d-flex gap-3 row row-cols-1 row-cols-sm-2 row-cols-md-3"
      >
        <LoadingSkeleton :class="`col ${$style.h40}`" />
        <LoadingSkeleton :class="`col ${$style.h40}`" />
        <LoadingSkeleton :class="`col ${$style.h40}`" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LoadingSkeleton } from '@hypercodestudio/basler-components';

interface Props {
  showCompareCheckbox?: boolean;
}

defineProps<Props>();
</script>

<style module>
.w10 {
  width: 10% !important;
}

.w80px {
  width: 80px !important;
}

.w15 {
  width: 15% !important;
}

.h20 {
  height: 20px !important;
}

.h30 {
  height: 30px !important;
}

.h40 {
  height: 40px !important;
}

.h80px {
  height: 80px !important;
}

.r50 {
  border-radius: 50% !important;
}

.compare-checkbox {
  margin-left: auto;
}
</style>
